"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var assert_valid_user_options_1 = __importDefault(require("./helpers/assert-valid-user-options"));

var suggest_email_1 = __importDefault(require("./suggest-email"));

var get_options_1 = __importDefault(require("./helpers/get-options"));

function run(userOptions) {
  var options = get_options_1.default(userOptions);
  assert_valid_user_options_1.default(options || {});
  var email = suggest_email_1.default(options);

  if (!email && userOptions.empty) {
    userOptions.empty();
  }

  if (email && userOptions.suggested) {
    userOptions.suggested(email);
  }

  return email;
}

exports.default = run;